module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mega-menu/menu-style5/menu-style5.component.scss
// module id = ./src/app/mega-menu/menu-style5/menu-style5.component.scss
// module chunks = main